const KEY_MANAGER_FETCH_KEYS = 'KEY_MANAGER_FETCH_KEYS';
const KEY_MANAGER_FETCH_KEYS_ERROR = 'KEY_MANAGER_FETCH_KEYS_ERROR';
const KEY_MANAGER_FETCH_KEYS_LOADING = 'KEY_MANAGER_FETCH_KEYS_LOADING';
const KEY_MANAGER_FETCH_KEYS_SUCCESS = 'KEY_MANAGER_FETCH_KEYS_SUCCESS';
const KEY_MANAGER_CREATE_KEY = 'KEY_MANAGER_CREATE_KEY';
const KEY_MANAGER_CREATE_KEY_ERROR = 'KEY_MANAGER_CREATE_KEY_ERROR';
const KEY_MANAGER_CREATE_KEY_LOADING = 'KEY_MANAGER_CREATE_KEY_LOADING';
const KEY_MANAGER_CREATE_KEY_SUCCESS = 'KEY_MANAGER_CREATE_KEY_SUCCESS';

const DISPLAY_CONFIRM = 'DISPLAY_CONFIRM';
const DISPLAY_PROGRESS = 'DISPLAY_PROGRESS';
const DISPLAY_SUCCESS = 'DISPLAY_SUCCESS';
const DISPLAY_ERROR = 'DISPLAY_ERROR';

export {
  KEY_MANAGER_FETCH_KEYS,
  KEY_MANAGER_FETCH_KEYS_ERROR,
  KEY_MANAGER_FETCH_KEYS_LOADING,
  KEY_MANAGER_FETCH_KEYS_SUCCESS,
  KEY_MANAGER_CREATE_KEY,
  KEY_MANAGER_CREATE_KEY_ERROR,
  KEY_MANAGER_CREATE_KEY_LOADING,
  KEY_MANAGER_CREATE_KEY_SUCCESS,
  DISPLAY_CONFIRM,
  DISPLAY_PROGRESS,
  DISPLAY_SUCCESS,
  DISPLAY_ERROR,
};
